import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const EcrfPopUpMessage = (props) => {
  return (
    <Dialog open onClose={() => props.setPopMessage(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        Are You Sure
        <IconButton
          aria-label="close"
          onClick={() => props.setPopMessage(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography align="center">
          You Want to Delete this Source Document (eCRF) Blocks?
        </Typography>
        <Typography align="center" color="error" sx={{ mt: 1 }}>
          Warning: This action will also delete the Patient Filled (eCRF) Forms as well.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => props.setPopMessage(false)}>
          No
        </Button>
        <Button variant="contained" color="error" onClick={() => props.confirmDelete(props.id)}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EcrfPopUpMessage;
